export enum FactorEnum {
  Password = "FACTOR_TYPE_PASSWORD",
  EmailCode = "FACTOR_TYPE_EMAIL_CODE",
  SmsCode = "FACTOR_TYPE_SMS_CODE",
  Unspecified = "FACTOR_TYPE_UNSPECIFIED",
  AskEmail = "FACTOR_TYPE_ASK_EMAIL",
  SetPassword = "FACTOR_TYPE_SET_PASSWORD",
}

export type TFactor = {
  factorId: string;
  factorType: FactorEnum;
  factorInfoMasked: string;
};
